import Stack, { type StackProps } from '@liquidweb-dev/undercurrent/Stack';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

import HookedCreditCardFields from 'components/Form/HookedCreditCardFields';
import HookedSubmit from 'components/Form/HookedSubmit';

export interface ChoosePaymentMethodAuthorizeDotNetProps extends StackProps {
	/** true while the entered card is being exchanged for opaque data */
	isSubmitting: boolean;
	/** true once Accept.js is loaded and able to take a card */
	readyToSubmit: boolean;
}

/** Collects a new card through Accept.js, for accounts without Stripe */
const ChoosePaymentMethodAuthorizeDotNet = ({
	isSubmitting,
	readyToSubmit,
	sx,
	...rest
}: ChoosePaymentMethodAuthorizeDotNetProps) => (
	<Stack sx={combineSx({ gap: 300 }, sx)} {...rest}>
		<HookedCreditCardFields />

		<HookedSubmit
			disabled={!readyToSubmit}
			loading={isSubmitting}
			size="large"
			color="highlight"
		>
			Continue
		</HookedSubmit>
	</Stack>
);

export default ChoosePaymentMethodAuthorizeDotNet;
